import React, { Suspense } from 'react';

import { useViewType, ViewType } from '@eika/hooks';

const SalaryInfoDesktopImg = React.lazy(() => import(`./SalaryInfoDesktopImg`));
const SalaryInfoMobileImg = React.lazy(() => import(`./SalaryInfoMobileImg`));

const MobileSkeleton = () => (
    <svg
        width="241"
        height="161"
        viewBox="0 0 241 161"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="salary-info-img"
    >
        <path
            d="M0 9.80087C0 4.388 4.388 0 9.80087 0H231.199C236.612 0 241 4.388 241 9.80087V151.138C241 156.551 236.612 160.939 231.199 160.939H9.80088C4.38801 160.939 0 156.551 0 151.138V9.80087Z"
            fill="#F7F4F2"
        />
    </svg>
);

const DesktopSkeleton = () => (
    <svg viewBox="0 0 401 165" fill="none" xmlns="http://www.w3.org/2000/svg" className="salary-info-img">
        <rect width="400" height="166" rx="12.4342" fill="#ECE5E0" />
    </svg>
);

export default () => {
    const viewType = useViewType();
    if (viewType === ViewType.mobile) {
        return (
            <Suspense fallback={<MobileSkeleton />}>
                <SalaryInfoMobileImg />
            </Suspense>
        );
    }
    return (
        <Suspense fallback={<DesktopSkeleton />}>
            <SalaryInfoDesktopImg />
        </Suspense>
    );
};
